import React, { Component } from 'react';
import { connect } from 'react-redux';
import Formsy from 'formsy-react';
import FormInput from '../../../components/common/elements/FormInput';
import translator from '../../../components/localization/translator';
import { Modal, FormControl, Glyphicon, Button } from 'react-bootstrap';
import FooterButtons from '../../../components/common/elements/FooterButtons';
import {showReportModal, hideReportModal, updateDistributorReport } from '../finance.actions';
import editableFields  from './editableFields';
import productEditableFields from './ProductEditableFields';
import InputWithLabel from '../../../components/common/elements/InputWithLabel';
import CollapseList from '../../../components/common/elements/collapseList';
import Notifier from '../../../components/message/Notifier';
import ToggleWithLabel from '../../../components/common/elements/ToggleWithLabel';
import { ENTER_KEY } from '../../../config/constants';

import '../../../components/common/elements/InputsStyle.css';

class ReportDetails extends Component {
    constructor(props){
		super(props);
		this.state = {
			propsReceived:false,
			isDisabled: true
		};
		this.cancel = this.cancel.bind(this);
		this.handleKeyPress= this.handleKeyPress.bind(this);
		this.save = this.save.bind(this);
		this.enableButton = this.enableButton.bind(this);
		this.disableButton = this.disableButton.bind(this);
	}

	componentWillReceiveProps(nextProps){
		if(nextProps.reportDetails && nextProps.reportDetails.show) {
			if(!this.state.propsReceived) {
				this.setState({
					...nextProps.reportDetails,
					forceGenerate: false,
					propsReceived: true
				});
			}
		}
	}

    cancel(){
		this.setState({propsReceived:false});
        this.props.hideReportModal();
	}

	save() {
		this.props.updateDistributorReport(this.state.shop._id, this.state, (data) => {
			Notifier.success('_report_successfully_updated_', '_report_updated_');
			this.setState({propsReceived:false});
			this.props.hideReportModal();
		});
    }

	renderFooter() {
		return (
			<Modal.Footer>
				<FooterButtons
					cancelButton={translator.translate("_cancel_")}
					saveButton={translator.translate("_save_")}
					save={this.save}
					cancel={this.cancel}
					isDisabled={this.state.isDisabled}
                    />
			</Modal.Footer>
		);
	}

	renderReportFields(){
		return (<React.Fragment>
			{editableFields.map((element, index)=>{
				return (
					<FormInput
						{...element}
						id={`${element.name}-${index}`}
						key={element.name}
						value={this.state[element.name] || ''}
						onChange={(e) => {
							this.calculateReport(element.name, e.target.value);
						}}/>
					);
				})}
		</React.Fragment>);
	}

	calculateReport(key, value){
		const report = this.state;
		report[key] = value;
		report.total = Number(report.price) + Number(report.delivery);
		this.setState(report);
	}

	calculateTotal( name, value) {
		const valueDifference = value - this.state[name];
		this.setState({
			delivery: value,
			total: this.state.total + valueDifference
		})
	}

	updateProductAndCalculateReport(index, key, value) {
		const shop = {...this.state.shop};
		const products = shop.products || [];
		products[index][key] = value;
		this.updateTotal(shop, products);
	}

	updateTotal(shop, products) {
		let total = this.state.delivery, driverExpenses = 0, price = 0, partnerDebt = 0;
		products.forEach((product) => {
			const quantity = product.quantity || 1;
			price = Number(price) + Number(quantity * product.price);
			total = Number(total) + Number(quantity * product.price);
			driverExpenses = Number(driverExpenses) + Number(quantity * product.driverExpenses);
			partnerDebt = Number(partnerDebt) + Number(quantity * product.partnerDebt);
		});
		shop.products = products;
		this.setState({ total, driverExpenses, price, partnerDebt, shop});
	}

	renderProductDetails(product, index){
		return (<div key={index} className={'display-flex'}>
				<div className={'col-xs-12 shop-list flex-box'}>
					{productEditableFields.map((element) => {
						return (
							<InputWithLabel
								key={element.name}
								type={element.type}
								id={element.name}
								value={this.state.shop.products[index][element.name]}
								disabled={product.isNew ? false : element.disabled}
								label={element.label}
								additionalStyle={element.additionalStyle}
								labelStyle={element.labelStyle}
								inputStyle={element.inputStyle}
								onChange={(e) => {
									this.updateProductAndCalculateReport(index, element.name, e.target.value);
								}}/>);
						})}
					<div className='flex-box align-center padding-horizontal col-xs-1'>
						<FormControl
							componentClass="select"
							onChange={(e) => {
								let arr = [...this.state.shop.products];
								arr[index].measurement = e.target.value;
								this.setState({
									shop: {
										products: arr
									}
								})
							}}
							disabled={false}
							defaultValue={this.state.shop.products[index].measurement}
							className={'select abel-distance'}>
								<option value={1}>{translator.translate('_quantity_count_')}</option>
								<option value={2}>{translator.translate('_quantity_kg_')}</option>
								<option value={3}>{translator.translate('_quantity_package_')}</option>
						</FormControl>
					</div>
					{this.renderRemoveProductButton(this.state.shop, product)}
				</div>
			</div>
		);
	}

	renderAddProduct(shop) {
		return (
			<Button
				className={'add-product'}
				bsStyle={'primary'}
				onClick={() => {
					let newProduct = {
						name: '',
						price: '',
						driverExpenses: '',
						quantity: '',
						isNew: true
					}
					shop.products.push(newProduct);
					this.forceUpdate();
				}}>
				<Glyphicon glyph={'plus-sign'} />
				<span className={'margin-to-left'}>{translator.translate('_add_product_')}</span>
			</Button>
		);
	}

	renderRemoveProductButton(shop, product) {
		return(
			<Button className={'pull-right shop-list col-xs-1 align-center'}
				bsStyle={'danger'}
				onClick={() => {
					let productIndex = shop.products.indexOf(product);
					shop.products.splice(productIndex, 1);
					this.forceUpdate();
					this.updateTotal(shop, shop.products);
				}}>
				<Glyphicon glyph={'trash trash-button'} />
			</Button>
		);
	}

	renderProductsList(){
		if(!this.state.shop) {
			return null;
		}
		return (
			<React.Fragment>
				{this.state.shop.products.map((product, index)=>{
					return this.renderProductDetails(product, index);
				})}
				{this.renderAddProduct(this.state.shop)}
			</React.Fragment>);
	}

	renderProducts() {
		return(
			<CollapseList
				isList={false}
				expanded={true}
				key={'products'}
				headerTitle={translator.translate("_products_label_")}
				child={this.renderProductsList()}
				childClassName={`shop-list`}
				editable={true} />
		);
	}

	renderForceGenerate() {
		return (
			<ToggleWithLabel
				onToggle={(forceGenerate)=>{
					this.setState({ forceGenerate });
				}}
				active={this.state.forceGenerate}
				onText={'_recalculate_report_'}
				offText={'_not_recalculate_report_'}
				offClassName="danger"
				label={'_status_'}
				htmlFor={'toggle'}
				style={{add:true}} />
		);
	}

	renderModalBody(){
		return (
			<React.Fragment>
				{this.renderForceGenerate()}
				{this.renderProducts()}
				{this.renderReportFields()}
			</React.Fragment>
		);
	}

	handleKeyPress(event) {
		if (event.charCode === ENTER_KEY.keyCode) {
			if (!this.state.isDisabled) {
				this.save();
			}
			return;
		}
	}

	enableButton() {
		this.setState({ isDisabled: false });
	}

	disableButton() {
		this.setState({ isDisabled: true });
	}

    render() {
        return(
            <Modal
				dialogClassName='large-modal'
				show={this.props.reportDetails.show}
				onKeyPress={this.handleKeyPress}
				onHide={this.cancel}>
				<Modal.Header closeButton>
					<Modal.Title>
						{translator.translate('_report_details_')}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body className="scrollable modal-possition">
					<Formsy onValid={this.enableButton} onInvalid={this.disableButton}>
						{this.renderModalBody()}
					</Formsy>
				</Modal.Body>
				{this.renderFooter()}
			</Modal>
        );
    }
}

const mapStateToProps = (state) => {
	return {
		reportDetails: state.reportDetails
	};
};

export default connect(
	mapStateToProps,
	{
        showReportModal,
		hideReportModal,
		updateDistributorReport
	}
)(ReportDetails);